export default __webpack_public_path__ + "media/savingcard.4fb6f6c0.svg";